import { Injectable } from '@angular/core';
import { Configuration } from '@app/core/config/configuration';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {

  private configuration: Configuration | null = null;

  public getConfig(): Configuration {
    if (this.configuration) {
      return this.configuration;
    }
    throw new Error("Configuration not yet loaded");
  }

  // the return value (Promise) of this method is used as an APP_INITIALIZER,
  // so the application's initialization will not complete until the Promise resolves.
  public load(): Promise<void> {
    if (this.configuration) {
      return Promise.resolve();
    }
    // TODO: Strategie betreffend Caching?
    return fetch(`config/config.json`)
      .then(response => response.json())
      .then(config => {
        this.configuration = config as Configuration;
      })
      .catch(error => {
        console.error('error loading configuration:', error);
      });
  }
}
